import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const carouselData = [
  { image: "./assets/bgHome/1.png", location: "Merlata Bloom Milano" },
  { image: "./assets/bgHome/2.png", location: "Menzino, Monte Isola" },
  { image: "./assets/bgHome/3.jpg", location: "Ponte che Balla, Clanezzo" },
  { image: "./assets/bgHome/4.png", location: "Palazzo Castiglioni, Milano" },
  { image: "./assets/bgHome/5.png", location: "Chiesa di San Luca, Brescia" },
  { image: "./assets/bgHome/6.png", location: "" },
  { image: "./assets/bgHome/7.png", location: "Wolfson College Buttery, Oxford" }
];

const variants = {
  enter: (direction) => ({
    x: direction > 0 ? 1000 : -1000,
    opacity: 0
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction) => ({
    zIndex: 0,
    x: direction < 0 ? 1000 : -1000,
    opacity: 0
  })
};

export default function ImageCarousel() {
  const [[page, direction], setPage] = useState([0, 0]);

  const paginate = useCallback((newDirection) => {
    setPage(([prevPage]) => [(prevPage + newDirection + carouselData.length) % carouselData.length, newDirection]);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(timer);
  }, [paginate]);

  const imageIndex = page % carouselData.length;

  return (
    <div className="absolute inset-0 overflow-hidden">
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={page}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 }
          }}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${carouselData[imageIndex].image})` }}
        >
          <div className="absolute bottom-6 right-6 bg-black/60 text-white px-4 py-2 rounded-lg backdrop-blur-sm">
            <span className="text-sm font-medium">{carouselData[imageIndex].location}</span>
          </div>
        </motion.div>
      </AnimatePresence>

      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/30 to-black/10" />

      {/* Navigation Arrows */}
      <button
        onClick={() => paginate(-1)}
        className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 transition-all"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={() => paginate(1)}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex items-center justify-center bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 transition-all"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2">
        {carouselData.map((_, index) => (
          <div
            key={index}
            onClick={() => setPage([index, index > imageIndex ? 1 : -1])}
            className={`w-2 h-2 rounded-full cursor-pointer transition-all ${index === imageIndex ? 'bg-amber-400 scale-125' : 'bg-white/50 hover:bg-white'
              }`}
          />
        ))}
      </div>
    </div>
  );
}